/* eslint-disable no-unused-vars */
export enum AuthType {
  LOGIN,
  REGISTRATION,
}
